import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook specifically designed for iOS Chrome scroll restoration issues
 * Uses more aggressive scroll restoration
 */
const useScrollRestoration = () => {
  const location = useLocation();
  const previousPathnameRef = useRef<string>();
  const timeoutRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    // Check if the pathname has actually changed
    const hasPathnameChanged = previousPathnameRef.current !== location.pathname;

    if (hasPathnameChanged) {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);

      // Initial delay for iOS timing
      timeoutRef.current = setTimeout(() => {
        requestAnimationFrame(() => {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        });
      });
    }

    // Update the previous pathname
    previousPathnameRef.current = location.pathname;

    // Cleanup timeouts on unmount
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [location.pathname]);

  return null;
};

export default useScrollRestoration;
